import styled from "styled-components";

export const ResizeListener = styled.div`
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
`;

export const ShadowUnder = styled.div`
  position: relative;
  z-index: 1;
  height: 5px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
`;

export const Base = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: hidden;
  position: relative;
`;
